// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo-module__Logo__3uA72","LogoIcon":"Logo-module__LogoIcon__21wPu","LogoSmall":"Logo-module__LogoSmall__1GBnO","LogoNavbar":"Logo-module__LogoNavbar__22L1D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Logo/Logo.module.css
// module id = 1701
// module chunks = 29